import { Directive, OnDestroy } from '@angular/core';

import { AccordionGroupItem } from '@app/shared/modules/accordion/models/accordion.models';

@Directive({ standalone: false, selector: '[adsptAccordionGroup]' })
export class AccordionGroupDirective implements OnDestroy {
  readonly registry = new Set<AccordionGroupItem>();

  register(accordion: AccordionGroupItem): void {
    this.registry.add(accordion);
  }

  toggle(accordion: AccordionGroupItem): void {
    if (accordion.expanded) {
      accordion.setExpanded(false);
    } else {
      this.registry.forEach((item) => item.setExpanded(item === accordion));
    }
  }

  unregister(accordion: AccordionGroupItem): void {
    this.registry.delete(accordion);
  }

  ngOnDestroy(): void {
    this.registry.clear();
  }
}
